class OtbNavbarController {
    constructor($state, $stateParams, authService) {
        'ngInject';
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.authService = authService;
        this.name = 'otbNavbar';
    }

    logout() {
        this.authService.logout().then(() => {
                this.$state.go('onTheBeach.login', {
                    locale: this.$stateParams.locale
                });
        });
    }
}

export default OtbNavbarController;



// WEBPACK FOOTER //
// ./client/app/common/otbNavbar/otbNavbar.controller.js